(function () {
  if (window.__rbCfgPackageCart) return;
  window.__rbCfgPackageCart = true;

  const Pkg = () => window.CfgPackage;
  let pending = null;
  let inFlight = false;

  function cssEscape(value) {
    const str = String(value == null ? "" : value);
    if (typeof CSS !== "undefined" && typeof CSS.escape === "function") return CSS.escape(str);
    return str.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  }

  function dialogEl() {
    return document.querySelector("dialog.rb-cfg-package-warn[data-rb-pkg-host]");
  }

  function hostDialog() {
    const existing = dialogEl();
    if (existing instanceof HTMLDialogElement) return existing;
    const source = document.querySelector("dialog.rb-cfg-package-warn");
    if (!(source instanceof HTMLDialogElement)) return null;
    const clone = source.cloneNode(true);
    if (!(clone instanceof HTMLDialogElement)) return null;
    clone.setAttribute("data-rb-pkg-host", "");
    document.body.appendChild(clone);
    return clone;
  }

  function settle(ok) {
    if (!pending) return;
    const resolve = pending;
    pending = null;
    resolve(!!ok);
  }

  function rowFromEvent(event) {
    const t = event.target;
    if (!(t instanceof Element)) return null;
    return t.closest("[data-rb-package-qty]");
  }

  function lineKey(row) {
    return row.getAttribute("data-item-key") || row.getAttribute("data-key");
  }

  function isLivePackageRow(row) {
    return !row.hasAttribute("data-rb-placeholder") && !!lineKey(row);
  }

  function revertRow(row) {
    const input = row.querySelector(
      'input[ref="quantityInput"], input[name="updates[]"], input[type="number"]'
    );
    const prev = row.getAttribute("data-rb-line-qty");
    if (input && prev != null) input.value = prev;
  }

  function networkErrorMessage() {
    return document.documentElement.lang === "fr"
      ? "Impossible de mettre à jour le panier. Actualisez la page et réessayez."
      : "Could not update the cart. Refresh the page and try again.";
  }

  function looksLikeHtml(text) {
    const s = String(text || "").trim();
    return /^<!DOCTYPE/i.test(s) || /^<html[\s>]/i.test(s) || s.indexOf("<script") !== -1;
  }

  function showRowError(row, err) {
    const cell = row.querySelector(".cart-items__error");
    if (!cell) return;
    let message = err && err.message ? String(err.message) : String(err || "");
    if (!message || looksLikeHtml(message) || message.length > 180) message = networkErrorMessage();
    const inner = cell.querySelector('[ref^="cartItemError-"]');
    if (inner) inner.textContent = message;
    else cell.textContent = message;
    cell.classList.remove("hidden");
  }

  function cartErrorText(res, data, text) {
    if (looksLikeHtml(text) || (text && !data)) return networkErrorMessage();
    if (data && typeof data === "object") {
      const errors = data.errors;
      if (typeof errors === "string" && errors) return errors;
      if (Array.isArray(errors) && errors.length) return errors.map(String).filter(Boolean).join(" ");
      if (errors && typeof errors === "object") {
        const parts = [];
        Object.keys(errors).forEach((key) => {
          const val = errors[key];
          if (Array.isArray(val)) parts.push(val.map(String).join(" "));
          else if (val) parts.push(String(val));
        });
        if (parts.length) return parts.join(" ");
      }
      if (data.description) return String(data.description);
      if (data.message) return String(data.message);
    }
    return (res && res.statusText) || networkErrorMessage();
  }

  function isCartFailure(res, data) {
    if (!res.ok) return true;
    if (!data || typeof data !== "object") return false;
    if (data.errors) return true;
    if (typeof data.status === "number" && data.status >= 400) return true;
    if (data.description && (data.message || data.status)) return true;
    return false;
  }

  async function postCart(url, body) {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });
    const text = await res.text();
    let data = null;
    try {
      data = text ? JSON.parse(text) : null;
    } catch (_) {}
    if (isCartFailure(res, data)) {
      throw new Error(cartErrorText(res, data, text));
    }
    return data;
  }

  function confirmIfNeeded(bundleId) {
    const pkg = Pkg();
    if (!pkg) return Promise.resolve(true);
    if (pkg.isPackageWarned(bundleId, window.sessionStorage)) return Promise.resolve(true);
    const dlg = bindDialog();
    if (!(dlg instanceof HTMLDialogElement)) return Promise.resolve(true);
    if (pending || dlg.open) return Promise.resolve(false);
    return new Promise((resolve) => {
      pending = resolve;
      try {
        dlg.showModal();
      } catch (_) {
        pending = null;
        resolve(false);
      }
    });
  }

  function bindDialog() {
    const dlg = hostDialog();
    if (!(dlg instanceof HTMLDialogElement)) return null;
    if (dlg.hasAttribute("data-rb-pkg-bound")) return dlg;
    dlg.setAttribute("data-rb-pkg-bound", "");

    dlg.addEventListener("click", (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest("[data-rb-pkg-continue]")) {
        settle(true);
        dlg.close();
      } else if (t.closest("[data-rb-pkg-cancel]") || t === dlg) {
        settle(false);
        dlg.close();
      }
    });

    dlg.addEventListener("cancel", () => {
      settle(false);
    });

    dlg.addEventListener("close", () => {
      if (pending) settle(false);
    });

    return dlg;
  }

  async function applyQty(row, quantity) {
    const bundleId = row.getAttribute("data-bundle-id");
    const key = lineKey(row);
    const isPlaceholder = row.hasAttribute("data-rb-placeholder");
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const sections = sectionIdsToUpdate();

    if (isPlaceholder || !key) {
      const pkg = Pkg();
      if (!pkg) throw new Error("CfgPackage is required to re-add package lines");
      let parsedP = {};
      try {
        parsedP = JSON.parse(row.getAttribute("data-readd") || "{}");
      } catch (_) {}
      const payload = pkg.buildReaddPayload({
        bundleId,
        entry: {
          k: row.getAttribute("data-cfg-key"),
          v: Number(row.getAttribute("data-variant-id")),
          q: Number(row.getAttribute("data-rec-qty")),
          p: parsedP,
        },
        quantity,
      });
      if (sections.length) {
        payload.sections = sections.join(",");
        payload.sections_url = window.location.pathname;
      }
      const data = await postCart(root + "cart/add.js", payload);
      dispatchCartUpdate(data, sections[0] || "");
      return;
    }

    await postCart(root + "cart/update.js", { updates: { [key]: quantity } });
  }

  function dispatchCartUpdate(data, sourceId) {
    document.dispatchEvent(
      new CustomEvent("cart:update", {
        bubbles: true,
        detail: {
          resource: data,
          sourceId: sourceId || "",
          data: {
            itemCount: data && data.item_count,
            source: "rb-cfg-package",
            sections: data && data.sections,
          },
        },
      })
    );
  }

  async function commitQty(row, quantity) {
    quantity = Math.floor(Number(quantity));
    if (!Number.isFinite(quantity) || quantity < 0) {
      revertRow(row);
      return;
    }
    if (Number(row.getAttribute("data-rb-line-qty")) === quantity) {
      const input = row.querySelector(
        'input[ref="quantityInput"], input[name="updates[]"], input[type="number"]'
      );
      const prev = row.getAttribute("data-rb-line-qty");
      if (input && prev != null && input.value !== prev) revertRow(row);
      return;
    }
    if (row.hasAttribute("data-rb-placeholder") && quantity === 0) {
      revertRow(row);
      return;
    }
    if (inFlight) {
      revertRow(row);
      return;
    }
    inFlight = true;
    try {
      const bundleId = row.getAttribute("data-bundle-id");
      const ok = await confirmIfNeeded(bundleId);
      if (!ok) {
        revertRow(row);
        inFlight = false;
        return;
      }
      await applyQty(row, quantity);
      const pkg = Pkg();
      if (pkg) pkg.markPackageWarned(bundleId, window.sessionStorage);
      inFlight = false;
    } catch (err) {
      console.error(err);
      revertRow(row);
      showRowError(row, err);
      inFlight = false;
    }
  }

  function replayQuantitySelectorUpdate(event) {
    const target = event.target;
    if (!(target instanceof EventTarget)) return;
    const detail = event.detail || {};
    target.dispatchEvent(
      new CustomEvent("quantity-selector:update", {
        bubbles: true,
        cancelable: true,
        detail: { quantity: detail.quantity, cartLine: detail.cartLine },
      })
    );
  }

  function fallbackTitle() {
    return document.documentElement.lang === "fr" ? "Produit" : "Product";
  }

  const productByHandle = {};

  async function fetchProductByHandle(handle) {
    const h = String(handle || "").trim();
    if (!h) return null;
    if (Object.prototype.hasOwnProperty.call(productByHandle, h)) return productByHandle[h];
    try {
      const res = await fetch(cartRoot() + "products/" + encodeURIComponent(h) + ".js", {
        headers: { Accept: "application/json" },
      });
      if (!res.ok) {
        productByHandle[h] = null;
        return null;
      }
      const data = await res.json();
      productByHandle[h] = data && typeof data === "object" ? data : null;
      return productByHandle[h];
    } catch (_) {
      productByHandle[h] = null;
      return null;
    }
  }

  function normalizeAssetUrl(src) {
    const s = String(src || "").trim();
    if (!s) return "";
    if (s.indexOf("//") === 0) return (window.location && window.location.protocol) + s;
    return s;
  }

  function imageSrcFromValue(value) {
    if (!value) return "";
    if (typeof value === "string") return normalizeAssetUrl(value);
    if (value.src) return normalizeAssetUrl(value.src);
    return "";
  }

  function productHref(product) {
    if (!product) return "";
    if (product.url) return String(product.url);
    if (product.handle) return "/products/" + product.handle;
    return "";
  }

  function productImageSrc(product, variantId) {
    if (!product) return "";
    const vid = Number(variantId);
    if (Number.isFinite(vid) && vid > 0 && Array.isArray(product.variants)) {
      for (let i = 0; i < product.variants.length; i++) {
        const variant = product.variants[i];
        if (Number(variant && variant.id) !== vid) continue;
        const fromVariant = imageSrcFromValue(variant.featured_image);
        if (fromVariant) return fromVariant;
      }
    }
    const fromFeat = imageSrcFromValue(product.featured_image);
    if (fromFeat) return fromFeat;
    if (Array.isArray(product.images) && product.images[0]) {
      return imageSrcFromValue(product.images[0]);
    }
    return "";
  }

  function fillPlaceholderMedia(tr, product, variantId) {
    const media = tr.querySelector(".cart-items__media");
    if (!media) return;
    media.innerHTML = "";
    const src = productImageSrc(product, variantId);
    if (!src) return;
    const img = document.createElement("img");
    img.className = "cart-items__media-image border-style";
    img.alt = (product && product.title) || "";
    img.src = src;
    const href = productHref(product);
    const wrap = document.createElement(href ? "a" : "div");
    wrap.className = "cart-items__media-container";
    wrap.style.setProperty("--ratio", "1");
    if (href) wrap.href = href;
    wrap.appendChild(img);
    media.appendChild(wrap);
  }

  function placeholderTitle(entry, product) {
    const pkg = Pkg();
    if (pkg && typeof pkg.placeholderDisplayTitle === "function") {
      return pkg.placeholderDisplayTitle(entry, product, fallbackTitle()) || fallbackTitle();
    }
    if (entry && entry.t) return String(entry.t);
    if (product && product.title) return String(product.title);
    return fallbackTitle();
  }

  function buildQtyControls(recQty) {
    const wrap = document.createElement("div");
    wrap.className = "cart-items__quantity-controls";

    const selectorWrap = document.createElement("div");
    selectorWrap.className = "quantity-selector-wrapper";

    const selector = document.createElement("div");
    selector.className = "quantity-selector cart-primary-typography quantity-selector--compact-mobile";

    const minus = document.createElement("button");
    minus.type = "button";
    minus.className = "button quantity-minus button-unstyled";
    minus.setAttribute("data-rb-pkg-delta", "-1");
    minus.setAttribute("aria-label", "decrease");
    minus.textContent = "−";

    const input = document.createElement("input");
    input.type = "number";
    input.value = "0";
    input.min = "0";
    input.step = "1";
    input.setAttribute("data-rb-line-qty", "0");

    const plus = document.createElement("button");
    plus.type = "button";
    plus.className = "button quantity-plus button-unstyled";
    plus.setAttribute("data-rb-pkg-delta", "1");
    plus.setAttribute("aria-label", "increase");
    plus.textContent = "+";

    selector.append(minus, input, plus);
    selectorWrap.appendChild(selector);

    const rec = document.createElement("span");
    rec.className = "cart-items__rec-qty";
    rec.setAttribute("aria-hidden", "true");
    rec.textContent = " / " + recQty;

    wrap.append(selectorWrap, rec);
    return wrap;
  }

  function setPlaceholderAttrs(tr, entry, recQty, bundleId) {
    tr.classList.add("cart-items__table-row", "cart-items__table-row--placeholder");
    tr.setAttribute("data-rb-package-qty", "");
    tr.setAttribute("data-rb-placeholder", "");
    tr.setAttribute("data-bundle-id", bundleId);
    tr.setAttribute("data-cfg-key", String(entry.k || ""));
    tr.setAttribute("data-rec-qty", String(recQty));
    tr.setAttribute("data-variant-id", String(entry.v == null ? "" : entry.v));
    tr.setAttribute("data-rb-line-qty", "0");
    tr.setAttribute("data-readd", JSON.stringify(entry.p || {}));
  }

  function buildMinimalPlaceholder(entry, recQty, bundleId, title) {
    const tr = document.createElement("tr");
    tr.setAttribute("role", "row");
    const cells = [
      ["cart-items__media", "productImage"],
      ["cart-items__details cart-primary-typography", "productInformation"],
      ["cart-items__unit-price cart-secondary-typography", "productPrice"],
      ["cart-items__quantity", "quantity"],
      ["cart-items__error hidden", "quantity"],
      ["cart-items__price cart-secondary-typography", "productTotal"],
      ["cart-items__remove-cell", "productRemove"],
    ];
    cells.forEach(([cls, headers]) => {
      const td = document.createElement("td");
      td.className = cls;
      td.setAttribute("role", "cell");
      td.setAttribute("headers", headers);
      tr.appendChild(td);
    });

    fillPlaceholderDetails(tr.querySelector(".cart-items__details"), entry, title);

    const qty = tr.querySelector(".cart-items__quantity");
    if (qty) qty.appendChild(buildQtyControls(recQty));

    setPlaceholderAttrs(tr, entry, recQty, bundleId);
    return tr;
  }

  function clonePlaceholderFromLive(template, entry, recQty, bundleId, title) {
    const tr = template.cloneNode(true);
    tr.removeAttribute("data-key");
    tr.removeAttribute("data-item-key");
    tr.removeAttribute("data-parent-key");
    tr.removeAttribute("ref");

    tr.querySelectorAll(".cart-items__remove, [onclick*='removeBundleItems']").forEach((el) => el.remove());

    const unit = tr.querySelector(".cart-items__unit-price");
    const price = tr.querySelector(".cart-items__price");
    if (unit) unit.innerHTML = "";
    if (price) price.innerHTML = "";

    const media = tr.querySelector(".cart-items__media");
    if (media) media.innerHTML = "";

    fillPlaceholderDetails(tr.querySelector(".cart-items__details"), entry, title);

    const qtyCell = tr.querySelector(".cart-items__quantity");
    if (qtyCell) {
      qtyCell.replaceChildren(buildQtyControls(recQty));
    }

    const error = tr.querySelector(".cart-items__error");
    if (error) error.innerHTML = "";

    setPlaceholderAttrs(tr, entry, recQty, bundleId);
    return tr;
  }

  function convertLiveRowToPlaceholder(row, entry, recQty, bundleId) {
    row.removeAttribute("data-key");
    row.removeAttribute("data-item-key");
    row.removeAttribute("data-parent-key");
    row.removeAttribute("ref");
    row.querySelectorAll(".cart-items__remove, [onclick*='removeBundleItems']").forEach((el) => el.remove());

    const unit = row.querySelector(".cart-items__unit-price");
    const price = row.querySelector(".cart-items__price");
    if (unit) unit.innerHTML = "";
    if (price) price.innerHTML = "";

    const qtyCell = row.querySelector(".cart-items__quantity");
    if (qtyCell) qtyCell.replaceChildren(buildQtyControls(recQty));

    const error = row.querySelector(".cart-items__error");
    if (error) error.innerHTML = "";

    setPlaceholderAttrs(row, entry, recQty, bundleId);
  }

  function insertPlaceholderRow(tbody, tr, hint) {
    if (hint && hint.before && hint.before.parentNode === tbody) {
      tbody.insertBefore(tr, hint.before);
      return;
    }
    if (hint && hint.after && hint.after.parentNode === tbody) {
      tbody.insertBefore(tr, hint.after.nextSibling);
      return;
    }
    const lastKeyed = Array.from(tbody.querySelectorAll("tr[data-cfg-key]")).pop();
    if (lastKeyed && lastKeyed.parentNode === tbody) {
      tbody.insertBefore(tr, lastKeyed.nextSibling);
      return;
    }
    const lastLocked = Array.from(tbody.querySelectorAll("tr")).filter(
      (row) => !row.hasAttribute("data-cfg-key")
    ).pop();
    if (lastLocked && lastLocked.parentNode === tbody) {
      tbody.insertBefore(tr, lastLocked.nextSibling);
      return;
    }
    tbody.appendChild(tr);
  }

  function reorderBundleRows(tbody, keys) {
    if (!tbody || !keys || !keys.length) return;
    const rows = Array.from(tbody.querySelectorAll("tr"));
    if (!rows.length) return;
    const locked = rows.filter((tr) => !tr.hasAttribute("data-cfg-key"));
    const byKey = new Map();
    rows.forEach((tr) => {
      const key = tr.getAttribute("data-cfg-key");
      if (key && !byKey.has(key)) byKey.set(key, tr);
    });
    const keyed = [];
    keys.forEach((key) => {
      const tr = byKey.get(key);
      if (tr) {
        keyed.push(tr);
        byKey.delete(key);
      }
    });
    byKey.forEach((tr) => keyed.push(tr));
    const desired = locked.concat(keyed);
    if (desired.length !== rows.length) return;
    let same = true;
    for (let i = 0; i < desired.length; i++) {
      if (desired[i] !== rows[i]) {
        same = false;
        break;
      }
    }
    if (same) return;
    desired.forEach((tr) => tbody.appendChild(tr));
  }

  function bundleRemoveHost(tbody, pkg) {
    const recordId = String((pkg && pkg.PROJECT_DETAILS_VARIANT_ID) || 52412839166241);
    return tbody.querySelector('tr[data-variant-id="' + recordId + '"]');
  }

  function buildBundleRemoveButton(bundleId) {
    const btn = document.createElement("button");
    btn.className = "button button--tertiary cart-items__remove";
    btn.type = "button";
    btn.setAttribute("onclick", "window.removeBundleItems(" + JSON.stringify(String(bundleId || "")) + ");");
    btn.textContent = document.documentElement.lang === "fr" ? "retirer" : "remove";
    return btn;
  }

  function ensureBundleRemove(tbody, pkg) {
    const record = bundleRemoveHost(tbody, pkg);
    if (!record) return;
    const cell = record.querySelector(".cart-items__remove-cell");
    if (!cell) return;
    const buttons = Array.from(tbody.querySelectorAll(".cart-items__remove, [onclick*='removeBundleItems']"));
    let hostBtn = buttons.find((btn) => record.contains(btn));
    buttons.forEach((btn) => {
      if (hostBtn && btn === hostBtn) return;
      if (hostBtn) {
        btn.remove();
        return;
      }
      cell.appendChild(btn);
      hostBtn = btn;
    });
    if (!hostBtn) cell.appendChild(buildBundleRemoveButton(tbody.getAttribute("data-bundle-id") || ""));
  }

  function fillPlaceholderDetails(details, entry, title, product) {
    if (!details) return;
    const p = document.createElement("p");
    const href = productHref(product);
    if (href) {
      const a = document.createElement("a");
      a.className = "cart-items__title";
      a.href = href;
      a.textContent = title;
      p.appendChild(a);
    } else {
      const span = document.createElement("span");
      span.className = "cart-items__title";
      span.textContent = title;
      p.appendChild(span);
    }

    const pkg = Pkg();
    const props = pkg ? pkg.customerProperties(entry && entry.p) : {};
    const keys = Object.keys(props);
    if (!keys.length) {
      details.replaceChildren(p);
      return;
    }

    const dl = document.createElement("dl");
    dl.className = "cart-items__variants";
    keys.forEach((key) => {
      const wrap = document.createElement("div");
      wrap.className = "cart-items__properties";
      const dt = document.createElement("dt");
      dt.textContent = key + ":";
      const dd = document.createElement("dd");
      dd.textContent = String(props[key]);
      wrap.append(dt, dd);
      dl.appendChild(wrap);
    });
    details.replaceChildren(p, dl);
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function changeUrl() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.cart_change_url) || cartRoot() + "cart/change.js";
  }

  function sectionIdsToUpdate() {
    const ids = [];
    document.querySelectorAll("cart-items-component").forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  let stashedPlaceholders = [];

  function stashPlaceholders() {
    document.querySelectorAll("tbody.-bundle tr[data-rb-placeholder]").forEach((tr) => {
      stashedPlaceholders.push(tr);
      tr.remove();
    });
  }

  function takeStashedPlaceholder(bundleId, cfgKey) {
    const i = stashedPlaceholders.findIndex(
      (tr) =>
        tr.getAttribute("data-bundle-id") === String(bundleId) &&
        tr.getAttribute("data-cfg-key") === String(cfgKey)
    );
    if (i < 0) return null;
    return stashedPlaceholders.splice(i, 1)[0];
  }

  function lineProperties(item) {
    return item && item.properties && typeof item.properties === "object" ? item.properties : {};
  }

  async function fetchCartItems() {
    try {
      const res = await fetch(cartRoot() + "cart.js", { headers: { Accept: "application/json" } });
      const data = await res.json();
      return Array.isArray(data && data.items) ? data.items : [];
    } catch (_) {
      return [];
    }
  }

  function snapshotForBundle(pkg, cartItems, bundleId, tbody) {
    const record = cartItems.find((item) => {
      const props = lineProperties(item);
      return (
        String(props._bundle_id) === String(bundleId) &&
        Number(item.variant_id) === pkg.PROJECT_DETAILS_VARIANT_ID
      );
    });
    if (record) {
      const decoded = pkg.decodeRecommendedBom(lineProperties(record));
      if (decoded.length) return decoded;
    }
    return pkg.parseSnapshotJson(tbody.getAttribute("data-rb-snapshot"));
  }

  function liveItemsForBundle(cartItems, tbody, bundleId) {
    const byKey = new Map();
    cartItems.forEach((item) => {
      if (item && item.key) byKey.set(String(item.key), item);
    });
    return Array.from(tbody.querySelectorAll("tr[data-cfg-key]:not([data-rb-placeholder])")).map((tr) => {
      const key = tr.getAttribute("data-item-key") || tr.getAttribute("data-key") || "";
      const item = key ? byKey.get(key) : null;
      const props = lineProperties(item);
      return {
        row: tr,
        properties: {
          _cfgKey: props._cfgKey || tr.getAttribute("data-cfg-key") || "",
          _bundle_id: props._bundle_id || bundleId,
          _cfgRecQty: props._cfgRecQty || "",
        },
        quantity: Number(item && item.quantity != null ? item.quantity : tr.getAttribute("data-rb-line-qty")),
        variant_id: item && item.variant_id != null ? item.variant_id : tr.getAttribute("data-variant-id"),
      };
    });
  }

  function applyRecQty(tr, recQty) {
    if (!tr || recQty == null) return;
    tr.setAttribute("data-rec-qty", String(recQty));
    const recEl = tr.querySelector(".cart-items__rec-qty");
    if (recEl) recEl.textContent = " / " + recQty;
  }

  let injecting = false;
  let injectAgain = false;

  async function injectPlaceholders() {
    if (injecting) {
      injectAgain = true;
      return;
    }
    injecting = true;
    try {
      do {
        injectAgain = false;
        await injectPlaceholdersOnce();
      } while (injectAgain);
    } finally {
      stashedPlaceholders = [];
      injecting = false;
    }
  }

  async function injectPlaceholdersOnce() {
    const pkg = Pkg();
    if (!pkg) return;
    const tbodies = document.querySelectorAll("tbody.-bundle[data-bundle-id]");
    const needsCart = Array.from(tbodies).some((tbody) => {
      return !pkg.parseSnapshotJson(tbody.getAttribute("data-rb-snapshot")).length;
    });
    const cartItems = needsCart ? await fetchCartItems() : [];

    for (const tbody of document.querySelectorAll("tbody.-bundle[data-bundle-id]")) {
      const bundleId = tbody.getAttribute("data-bundle-id") || "";
      const snapshot = snapshotForBundle(pkg, cartItems, bundleId, tbody);
      const liveItems = liveItemsForBundle(cartItems, tbody, bundleId);
      const rows = pkg.mergePackageRows(snapshot, liveItems);
      const liveTemplate = tbody.querySelector("tr[data-cfg-key]:not([data-rb-placeholder])");

      rows.forEach((merged) => {
        if (merged.kind === "live") {
          applyRecQty(merged.item && merged.item.row, pkg.liveOverlayRecQty(merged));
        }
      });

      const pendingMedia = [];
      for (let index = 0; index < rows.length; index++) {
        const merged = rows[index];
        if (merged.kind !== "placeholder") continue;
        const entry = merged.entry || {};
        const key = String(entry.k || "");
        if (!key) continue;
        if (tbody.querySelector('tr[data-rb-placeholder][data-cfg-key="' + cssEscape(key) + '"]')) continue;

        const recQty = merged.recQty;
        const hint = pkg.placeholderInsertHint(rows, index);
        let tr = takeStashedPlaceholder(bundleId, key);
        if (!tr) {
          tr = liveTemplate
            ? clonePlaceholderFromLive(liveTemplate, entry, recQty, bundleId, placeholderTitle(entry, null))
            : buildMinimalPlaceholder(entry, recQty, bundleId, placeholderTitle(entry, null));
        }

        insertPlaceholderRow(tbody, tr, hint);
        if (!tr.querySelector(".cart-items__media img")) pendingMedia.push({ tr, entry, key });
      }

      if (typeof pkg.packageRowKeys === "function") {
        reorderBundleRows(tbody, pkg.packageRowKeys(rows));
      }
      ensureBundleRemove(tbody, pkg);

      for (const item of pendingMedia) {
        const product = await fetchProductByHandle(item.entry.h);
        const current = tbody.querySelector('tr[data-rb-placeholder][data-cfg-key="' + cssEscape(item.key) + '"]');
        if (!product || !current) continue;
        fillPlaceholderDetails(
          current.querySelector(".cart-items__details"),
          item.entry,
          placeholderTitle(item.entry, product),
          product
        );
        fillPlaceholderMedia(current, product, item.entry.v);
      }
    }
  }

  async function zeroLiveAndSync(row) {
    const shopifyKey = lineKey(row);
    if (!shopifyKey) return;
    const pkg = Pkg();
    const bundleId = row.getAttribute("data-bundle-id") || "";
    const tbody = row.closest("tbody.-bundle");
    const snapshot = pkg && tbody ? snapshotForBundle(pkg, [], bundleId, tbody) : [];
    const cfgKey = row.getAttribute("data-cfg-key") || "";
    const entry =
      snapshot.find((item) => String(item.k) === cfgKey) || {
        k: cfgKey,
        v: row.getAttribute("data-variant-id"),
        q: row.getAttribute("data-rec-qty"),
        p: {},
      };
    const recQty = Number(entry.q) || Number(row.getAttribute("data-rec-qty")) || 0;

    const sections = sectionIdsToUpdate();
    const payload = { id: shopifyKey, quantity: 0 };
    if (sections.length) {
      payload.sections = sections.join(",");
      payload.sections_url = window.location.pathname;
    }
    const data = await postCart(changeUrl(), payload);
    convertLiveRowToPlaceholder(row, entry, recQty, bundleId);
    dispatchCartUpdate(data, sections[0] || "");
  }

  function onReady() {
    bindDialog();
    injectPlaceholders();
  }

  document.addEventListener(
    "quantity-selector:update",
    async (event) => {
      const row = rowFromEvent(event);
      if (!row || row.hasAttribute("data-rb-placeholder")) return;
      const pkg = Pkg();
      const bundleId = row.getAttribute("data-bundle-id");
      const quantity = Math.floor(Number(event.detail && event.detail.quantity));
      if (pkg && pkg.isPackageWarned(bundleId, window.sessionStorage) && quantity !== 0) return;
      if (!pkg) {
        if (!isLivePackageRow(row)) {
          event.stopImmediatePropagation();
          revertRow(row);
        }
        return;
      }
      event.stopImmediatePropagation();
      if (!Number.isFinite(quantity) || quantity < 0) {
        revertRow(row);
        return;
      }
      if (Number(row.getAttribute("data-rb-line-qty")) === quantity) {
        revertRow(row);
        return;
      }
      if (inFlight) {
        revertRow(row);
        return;
      }
      inFlight = true;
      try {
        const ok = await confirmIfNeeded(bundleId);
        if (!ok) {
          revertRow(row);
          inFlight = false;
          return;
        }
        pkg.markPackageWarned(bundleId, window.sessionStorage);
        if (quantity === 0) {
          await zeroLiveAndSync(row);
          inFlight = false;
          return;
        }
        inFlight = false;
        replayQuantitySelectorUpdate(event);
      } catch (err) {
        console.error(err);
        revertRow(row);
        showRowError(row, err);
        inFlight = false;
      }
    },
    true
  );

  document.addEventListener(
    "cart:update",
    () => {
      stashPlaceholders();
      window.setTimeout(() => {
        injectPlaceholders();
      }, 0);
    },
    true
  );

  document.addEventListener(
    "mousedown",
    (event) => {
      const t = event.target;
      if (!(t instanceof Element)) return;
      const btn = t.closest("[data-rb-pkg-delta]");
      if (!btn) return;
      const row = btn.closest("[data-rb-placeholder]");
      if (!row) return;
      // Keep the number input focused so a following click does not also fire `change`.
      event.preventDefault();
    },
    true
  );

  document.addEventListener(
    "click",
    (event) => {
      const t = event.target;
      if (!(t instanceof Element)) return;
      const btn = t.closest("[data-rb-pkg-delta]");
      if (!btn) return;
      if (!btn.closest("[data-rb-package-qty]")) return;
      event.preventDefault();
      const row = btn.closest("tr");
      if (!row) return;
      const delta = Number(btn.getAttribute("data-rb-pkg-delta"));
      if (!Number.isFinite(delta) || delta === 0) return;
      const input = row.querySelector("input");
      const current = Number(input && input.value) || 0;
      if (delta < 0 && current <= 0) return;
      const newQty = Math.max(0, current + delta);
      if (input) input.value = String(newQty);
      commitQty(row, newQty);
    },
    true
  );

  function placeholderQtyInput(event) {
    const t = event.target;
    if (!(t instanceof HTMLInputElement) || t.type !== "number") return null;
    const row = t.closest("[data-rb-placeholder]");
    if (!row) return null;
    return { input: t, row };
  }

  document.addEventListener(
    "change",
    (event) => {
      const found = placeholderQtyInput(event);
      if (!found) return;
      commitQty(found.row, Number(found.input.value));
    },
    true
  );

  document.addEventListener(
    "keydown",
    (event) => {
      if (event.key !== "Enter") return;
      const found = placeholderQtyInput(event);
      if (!found) return;
      event.preventDefault();
      found.input.blur();
    },
    true
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }
})();
